var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',_vm._g(_vm._b({attrs:{"items":_vm.breadcrumbs,"active-class":"breadcrumb-active"},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}])},'v-breadcrumbs',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }